const DataFrequency =[
    { value: 'Transaction', label: 'Transaction' , disabledValues:[] },
    { value: 'Daily', label: 'Daily' , disabledValues:[] },
    { value: 'Weekly', label: 'Weekly' , disabledValues:[] },
    { value: 'Monthly', label: 'Monthly' , disabledValues:['Weekly'] },
    { value: 'Quarterly', label: 'Quarterly' , disabledValues:['Weekly','Monthly'] }
  ]

 const ForecastPeriods = [
    {
      frequency : 'Daily',
      periods : ['15 Days', '30 Days']
    },
    {
      frequency : 'Weekly',
      periods : [
        "For next 1 week",
        "For next 2 weeks",
        "For next 3 weeks",
        "For next 4 weeks",
        "For next 5 weeks",
        "For next 6 weeks",
        "For next 7 weeks",
        "For next 8 weeks",
        "For next 9 weeks",
        "For next 10 weeks",
        "For next 11 weeks",
        "For next 12 weeks",
        "For next 13 weeks",
        "For next 14 weeks",
        "For next 15 weeks",
        "For next 16 weeks",
        "For next 17 weeks",
        "For next 18 weeks",
        "For next 19 weeks",
        "For next 20 weeks",
        "For next 21 weeks",
        "For next 22 weeks",
        "For next 23 weeks",
        "For next 24 weeks",
        "For next 25 weeks",
        "For next 26 weeks",
        "For next 27 weeks",
        "For next 28 weeks",
        "For next 29 weeks",
        "For next 30 weeks",
        "For next 31 weeks",
        "For next 32 weeks",
        "For next 33 weeks",
        "For next 34 weeks",
        "For next 35 weeks",
        "For next 36 weeks",
        "For next 37 weeks",
        "For next 38 weeks",
        "For next 39 weeks",
        "For next 40 weeks",
        "For next 41 weeks",
        "For next 42 weeks",
        "For next 43 weeks",
        "For next 44 weeks",
        "For next 45 weeks",
        "For next 46 weeks",
        "For next 47 weeks",
        "For next 48 weeks",
        "For next 49 weeks",
        "For next 50 weeks",
        "For next 51 weeks",
        "For next 52 weeks"
    ]
    },
    {
      frequency : 'Monthly',
      periods : [
        "For next 1 month",
        "For next 2 months",
        "For next 3 months",
        "For next 4 months",
        "For next 5 months",
        "For next 6 months",
        "For next 7 months",
        "For next 8 months",
        "For next 9 months",
        "For next 10 months",
        "For next 11 months",
        "For next 12 months"
    ]
    },
    {
      frequency : 'Quarterly',
      periods :  [
        "For next 3 Quarters",
        "For next 6 Quarters",
        "For next 9 Quarters",
        "For next 12 Quarters"
    ]
    },
  ]

  
const GranularityList =[ 
  { id: 'Weekly', label: 'Weekly' },
  { id: 'Monthly', label: 'Monthly' },
  { id: 'Quarterly', label: 'Quarterly' }
]

  export { DataFrequency, ForecastPeriods, GranularityList}